import {json, JsonMappers} from '../../../core/data-source/json.mapper';
import {VehicleChecksFieldRecord} from './vehicle-checks-field.record';

export class VehicleCheckRecord {
    @json()
    name: string;

    @json({
        skip: true,
        jsonName: 'reference'
    })
    id: string;

    @json()
    description: string;

    @json({
        value: [],
        mapper: JsonMappers.ArrayOf(() => VehicleChecksFieldRecord)
    })
    fields: VehicleChecksFieldRecord[];
}
